import React from "react";

export default function PostContainer({ children }) {
  return <section className="post-page-container">{children}</section>;
}
